import PropTypes from 'prop-types';
import { useContext, useRef } from 'react';
import * as yup from 'yup';
import AuthContext from 'context/authContext';
import CrudCard from '../../common/CrudCard/CrudCard';
import {
  useDonationTypes,
  useCreateDonationType,
  useUpdateDonationType,
  useDeleteDonationType
} from 'hooks/useDonationSettings';

/* -------------------------------------------------------------------------- */
function DonationTypes({ sectionRef, sideNavLink, subject }) {
  const cardRef = useRef();
  const { organization } = useContext(AuthContext);

  const { donationTypes, isLoading: loading } = useDonationTypes();
  const { createDonationType, isCreating: createLoading } = useCreateDonationType();
  const { updateDonationType, isUpdating: updateLoading } = useUpdateDonationType();
  const { deleteDonationType, isDeleting: deleteLoading } = useDeleteDonationType();

  const handleCreate = async (data) => {
    try {
      await createDonationType({
        donation_type_name: data.donation_type_name,
        organisation_id: organization.id
      });
      cardRef.current.onCreationSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdate = async (data) => {
    try {
      await updateDonationType({
        id: data.id,
        data: { donation_type_name: data.donation_type_name }
      });
      cardRef.current.onEditSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDonationType(id);
      cardRef.current.onDeleteSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const sortedDonationTypes = [...(donationTypes || [])].sort((a, b) => {
    if (a.donation_type_name === 'General') return -1;
    if (b.donation_type_name === 'General') return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  });
  const list = sortedDonationTypes.map(type => ({
    id: type.id,
    isOrgLevel: !type.branch_id,
    values: [
      {
        value: type.donation_type_name,
        name: 'donation_type_name',
        isActionsHidden: type.donation_type_name === 'General'
      }
    ]
  }));

  return (
    <CrudCard
      ref={cardRef}
      sectionRef={sectionRef}
      sideNavLink={sideNavLink}
      createData={handleCreate}
      loading={loading}
      editData={handleUpdate}
      deleteData={handleDelete}
      createLoading={createLoading}
      updateLoading={updateLoading}
      deleteLoading={deleteLoading}
      formTitle={'Add Donation Types'}
      listTitle={'Current Donation Types'}
      title={'Donation Types'}
      inputs={[
        {
          name: 'donation_type_name',
          placeholder: 'Add Donation Type',
          type: 'text',
          required: true,
          value: '',
          validation: yup.string().required('Donation Type is required')
        }
      ]}
      list={list}
      subject={subject}
    />
  );
}

DonationTypes.propTypes = {
  sectionRef: PropTypes.any,
  sideNavLink: PropTypes.any,
  subject: PropTypes.string
};

export default DonationTypes;
